import { SvgStyled } from '../../components/Global/Atomics/SvgStyled';

const UserGroup_xl = (props) => {
    const width = props.width ? props.width + 'px' : '40px';
    const height = props.height ? props.height + 'px' : '40px';

    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 40 40"
            fill={props.fill ? props.fill : 'none'}
            customColor={props.customColor}
            width={width}
            height={height}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M22.0559 21.8125C23.0231 20.6025 23.6013 19.068 23.6013 17.3985C23.6013 16.8873 23.5471 16.3888 23.4441 15.9084C24.7858 14.1708 26.8896 13.0516 29.2548 13.0516C33.3069 13.0516 36.5918 16.3365 36.5918 20.3886C36.5918 23.6514 34.462 26.4168 31.5167 27.3703C34.4045 27.998 36.5777 29.824 37.8799 32.2353C38.1424 32.7212 37.9612 33.3279 37.4752 33.5904C36.9893 33.8528 36.3826 33.6716 36.1202 33.1857C34.8204 30.7791 32.4933 29.1338 29.2548 29.1338C26.9053 29.1338 25.0354 29.9999 23.6896 31.3944C23.2624 30.8751 22.7295 30.4461 22.1238 30.1403C23.3798 28.7878 25.0195 27.7992 26.993 27.3703C24.4875 26.5592 22.5721 24.4368 22.0559 21.8125ZM29.2548 15.0516C26.3073 15.0516 23.9179 17.4411 23.9179 20.3886C23.9179 23.3361 26.3073 25.7256 29.2548 25.7256C32.2024 25.7256 34.5918 23.3361 34.5918 20.3886C34.5918 17.4411 32.2024 15.0516 29.2548 15.0516Z"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M14.4258 8C9.81511 8 6.07738 11.7377 6.07738 16.3485C6.07738 20.9592 9.81511 24.6969 14.4258 24.6969C19.0366 24.6969 22.7743 20.9592 22.7743 16.3485C22.7743 11.7377 19.0366 8 14.4258 8ZM4.07738 16.3485C4.07738 10.6332 8.71054 6 14.4258 6C20.1411 6 24.7743 10.6332 24.7743 16.3485C24.7743 22.0637 20.1411 26.6969 14.4258 26.6969C8.71054 26.6969 4.07738 22.0637 4.07738 16.3485ZM14.4258 28.7743C9.46126 28.7743 5.87404 31.3087 3.87983 35.0012C3.61738 35.4871 3.01069 35.6683 2.52475 35.4059C2.03881 35.1434 1.85763 34.5367 2.12007 34.0508C4.4376 29.7596 8.67345 26.7743 14.4258 26.7743C20.1782 26.7743 24.4141 29.7596 26.7316 34.0508C26.994 34.5367 26.8129 35.1434 26.3269 35.4059C25.841 35.6683 25.2343 35.4871 24.9718 35.0012C22.9776 31.3087 19.3904 28.7743 14.4258 28.7743Z"
            />
        </SvgStyled>
    );
};

export default UserGroup_xl;
